export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full">
              <div className="aspect-[16/10] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20home%20entertainment%20setup%20with%20large%20screen%20displaying%20cinematic%20movie%20scene%2C%20cozy%20living%20room%20with%20warm%20ambient%20lighting%2C%20comfortable%20sofa%20and%20minimalist%20decor%2C%20streaming%20device%20on%20media%20console%2C%20evening%20atmosphere%20with%20soft%20lamp%20glow%2C%20premium%20home%20cinema%20experience%2C%20warm%20and%20inviting%20interior%20design&width=900&height=563&seq=about-visual-51movie&orientation=landscape"
                  alt="51影视 - 随时随地高清观影体验"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="flex-1 w-full">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-5">
                关于51影视
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  51影视网成立于2020年，是国内领先的<strong>免费影视在线观看平台</strong>。我们致力于为每一位影视爱好者提供<strong>高清不卡顿、不缓冲</strong>的极致观影体验，让好内容触手可及。
                </p>
                <p>
                  平台汇聚超过<strong>10万部影视资源</strong>，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。从院线大片到热门剧集，从经典老片到最新番剧，真正做到<strong>海量视频免费看</strong>。
                </p>
                <p>
                  采用智能CDN加速与自适应码率技术，无论你是用电脑、平板还是手机，都能享受<strong>流畅播放</strong>的高清画质。每日同步更新片库，让你不错过任何一部好剧。
                </p>
              </div>
              <div className="flex flex-wrap gap-6 mt-8">
                <div className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 text-xl"></i>
                  <span className="text-sm text-foreground-700">全高清画质</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 text-xl"></i>
                  <span className="text-sm text-foreground-700">每日更新片库</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 text-xl"></i>
                  <span className="text-sm text-foreground-700">多设备兼容</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 text-xl"></i>
                  <span className="text-sm text-foreground-700">无需注册</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}